import { render, staticRenderFns } from "./bonus.vue?vue&type=template&id=19c497ef"
import script from "./bonus.vue?vue&type=script&lang=js"
export * from "./bonus.vue?vue&type=script&lang=js"
import style0 from "./bonus.vue?vue&type=style&index=0&id=19c497ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports